// 미선택 상태에서 임의의 인증값을 만들지 않는다. 비밀을 로그에 남기지 않는다.
export function makeRdpRequest(hostname, port, credential) {
  const username = typeof credential?.infra_acc_user === "string"
    ? credential.infra_acc_user : credential?.infra_acc_label || "";
  return {
    Hostname: hostname,
    Port: port,
    Username: username,
    Password: username ? credential?.infra_acc_pass || "" : "",
  };
}
